/**
 * Whether Flow itself is down right now (a deploy restarting the gateway or the BFF), as seen by the requests that open
 * a project (MiaPlatformDataService: the project's configuration, revisions, services). Only those count: a preview's
 * 503 (the app is not running), a connector's 503 ("Connectors need LiteLLM") or a stopped service is not Flow being
 * updated. ProjectLoading shows "We're coming back soon" only while this says so.
 *
 * Flow is down from a 502/503/504 or a request that got no answer at all (network error), until one of those requests
 * is answered again.
 */
export const FLOW_OUTAGE_EVENT = 'flow-outage-changed';

const OUTAGE_STATUSES = new Set([502, 503, 504]);
let down = false;

function set(next) {
  if (down === next) { return; }
  down = next;
  if (typeof window !== 'undefined') { window.dispatchEvent(new CustomEvent(FLOW_OUTAGE_EVENT, { detail: { down } })); }
}

/** A Flow request failed: `status` its HTTP status, or none when it got no answer (network error). Any other status
 * (404, 403, 500…) is Flow answering. */
export function noteFlowFailure(status) {
  set(status === undefined || status === null || OUTAGE_STATUSES.has(status));
}

/** A Flow request was answered (any answer that is not an outage status). */
export function noteFlowAnswered() {
  set(false);
}

export function isFlowDown() {
  return down;
}

/** Tests only. */
export function resetFlowOutage() {
  down = false;
}
